import { useEffect, useState } from 'react';
import { Chip } from '@mui/material';
import Avatar from './Avatar';
import useCachedUserList from '@src/adapters/hooks/user/useCachedUserList';

interface Props {
  id: string;
}

function CrewName({ id }: Props) {
  const { getList } = useCachedUserList();
  const [display, setDisplay] = useState('');
  const [avatarURL, setAvatarURL] = useState('');

  useEffect(() => {
    getList(id).then((user) => {
      if (user && user.length === 1) {
        setDisplay(`${user[0].firstName} ${user[0].lastName}`);
      }
      // setAvatarURL(ui.avatarUrl);
    });
  }, [getList, id]);

  return (
    <Chip
      avatar={<Avatar url={avatarURL} showOutline={false} />}
      label={display}
    />
  );
}

export default CrewName;
